module.exports = __webpack_public_path__ + "img/bikini-martini.1038f223.jpg";